import React, { useContext, useEffect } from 'react';
import { get } from 'lodash';
import withRouter from 'react-router/withRouter';
import loadPianoData from '../piano_pages_state_manager';
import { UserContext } from '../../../components/context/userContext';

const OfferPage = props => {
  const { showOffer } = useContext(UserContext);

  useEffect(() => {
    const defaultOfferId = 'OFC77Q9UWPQM'; // Default Piano offer ID
    const defaultTemplateId = 'OTQCOOTK4JS2'; // Default Piano template ID
    const offerId = get(props, 'match.params.offerId', defaultOfferId); // Determined Piano offer ID
    const templateId = get(props, 'match.params.templateId', defaultTemplateId); // Determined Piano template ID

    showOffer(offerId, templateId, 'inline', '.piano-offer-container');
  }, []);

  return (
    <React.Fragment>
      <div className="piano-page-container offer">
        <div className="piano-offer-container" />
      </div>
    </React.Fragment>
  );
};

OfferPage.loadData = store => loadPianoData(store);

export default withRouter(OfferPage);
